// extracted by mini-css-extract-plugin
var _1 = "UserRateLimitModal__buttons--LVlLJ ModalGeneral__buttons--T6m1m";
var _2 = "UserRateLimitModal__darkerBackdrop--shIGq GlobalModal__darkerBackdrop--dvCvH";
var _3 = "UserRateLimitModal__errorImage--fQJvJ GlobalModal__errorImage--fjLqn ErrorMessage__imageBase--SmEk7";
var _4 = "UserRateLimitModal__errorMessage--BSQ5l GlobalModal__errorMessage--PhURi ErrorMessage__messageBase--GMVXk";
var _5 = "UserRateLimitModal__wrapper--qTH2q GlobalModal__wrapper--NGO7l";
export { _1 as "buttons", _2 as "darkerBackdrop", _3 as "errorImage", _4 as "errorMessage", _5 as "wrapper" }
